import {animateByClass} from '../Library/Animation';

export const syncWarehouseMappingDirection = select => {
    const cell = select.closest('tr').querySelector('.sync-direction');
    const isMapped = select.value !== '';

    cell.classList.toggle('mapped', isMapped);
    cell.classList.remove('pop');

    if (!isMapped) {
        return;
    }

    void cell.offsetWidth;
    animateByClass(cell, 'pop');
};
